import React, { useState } from "react";
import { Row, Col, Card, Dropdown, Table, Modal, Button, Container } from "react-bootstrap";
import ModalManager from "../ModalManager";
import SwalMessage from "../../../_Components/SwalMessage";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircle";
import _ from "lodash";
import classNames from "classnames";
import "./style.css";
import BlockIcon from "@mui/icons-material/Block";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // استایل پیش‌فرض

function BasketCanceledItemsIndex(props) {
  const pageHeight = window.innerHeight;
  //PART 1 --------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  const [checkBoxList, setCheckBoxList] = useState([]); //-----------------------لیستی از افرادی که برای انجام عملیات انتخاب میشوند
  let showPrice = Intl.NumberFormat("en-US");
  //PART 3 -----------------------مدیریت مدال های  صفحه ---------------------------------------------------------------------------------------------------------------------------
  const [Modali, setItem] = ModalManager();
  const [loadingData, setLoadingData] = useState(false);
  const [stepCompleted, setStepCompleted] = useState({
    step1: false,
    step2: false,
    deleteStep1: false,
    deleteStep2: false,
  });
  const handleShow = ({ nameModal, size, data }) => {
    setItem({ show: true, size: size, nameModal: nameModal, data: data });
  };
  // -- مدیریت مدال انتخابی کاربر
  const handleModalGaranty = (checkBoxList, typeOfModal) => {
    setLoadingData(true)
    // بررسی ورودی ها
    if (
      typeOfModal == "CancelStatus" ||
      typeOfModal == "FineAmount" ||
      typeOfModal == "SupplierCancelStatus" ||
      typeOfModal == "DeleteOprationCancelStatus" ||
      typeOfModal == "DeleteOprationSupplierCancelStatus"
    )
      if (!checkBoxList || checkBoxList.length <= 0) {
        setShowStepModal(false);
        setShowFineRegisterModal(false);
        SwalMessage({
          title: "جهت ادامه فرایند ابتدا آیتم های مدنظر را انتخاب نمایید.",
          iSsuccess: false,
          timer: 4000,
        });
        return;
      }
    if (typeOfModal == "FineAmount") setShowFineRegisterModal(true);
    else if (typeOfModal == "CancelStatus" || typeOfModal == "SupplierCancelStatus") setShowStepModal(true);
    // نمایش مدال
    if (
      !_.isEmpty(typeOfModal) &&
      (typeOfModal == "CancelStatus" || typeOfModal == "FineAmount" || typeOfModal == "DeleteOprationCancelStatus")
    ) {
      handleShow({
        nameModal: "ModalUpdatePersonInItemsCanceled",
        size: "xl",
        data: {
          bascketPersons: checkBoxList,
          callBack: props.callBack,
          basketId: props.basketId,
          typeOfModal: typeOfModal,
          setStepCompleted: setStepCompleted,
        },
      });
    }
    // نمایش مدال
    if (
      !_.isEmpty(typeOfModal) &&
      (typeOfModal == "SupplierCancelStatus" || typeOfModal == "DeleteOprationSupplierCancelStatus")
    ) {
      handleShow({
        nameModal: "ModalUpdatePersonInItemsSupplierCanceled",
        size: "xl",
        data: {
          bascketPersons: checkBoxList,
          callBack: props.callBack,
          basketId: props.basketId,
          typeOfModal: typeOfModal,
          setStepCompleted: setStepCompleted,
        },
      });
    }
    setLoadingData(false);
  };
  // PART 5------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
  // handleSelect add or remove item id from checkBox list
  const handleSelect = (item) => {
    const { id, currentStatus, cancelStatus, supplierCancelStatus } = item;
    if (cancelStatus == null) return;
    const data = {
      id: id,
      current: currentStatus,
      cancelStatus: cancelStatus,
      supplierCancelStatus: supplierCancelStatus,
    };
    checkBoxList.some((item) => data.id === item.id) // checking if the item selected exits in checkBoxList
      ? setCheckBoxList((checkBoxList) => checkBoxList.filter((item) => item.id != data.id)) // remove the item if exists
      : setCheckBoxList((checkBoxList) => [...checkBoxList, data]); // add the item if doesn't exist
  };
  // select all button
  const handleAllSelect = (list, boolian) => {
    if (!boolian) {
      // اون هایی رو چدا کن که داخل checkBoxList نیستن
      const listFalseItem = list.filter((item) => !checkBoxList.some((data) => item.id === data.id));
      // اون هارو به ckeckBoxList اضافه کن
      listFalseItem.map((item) => handleSelect(item));
    } else if (boolian) {
      // listTrueItem = اون هایی رو جدا کن که داخل CheckBoxList وجود دارن
      const listTrueItem = list.filter((item) => checkBoxList.some((data) => item.id === data.id));
      listTrueItem.map((item) => handleSelect(item));
    }
  };
  // =--------------------------------------------------------------------------------

  function showDetail(prp) {
    let resDetails = "";
    let jsonparser = JSON?.parse(prp);
    !_.isEmpty(jsonparser) &&
      jsonparser.map((item, index) => {
        if (_.isEmpty(resDetails)) resDetails += item.text;
        else resDetails += " , " + item.text;
      });
    return resDetails != "" ? resDetails : "ندارد";
  }
  const deleteCancellationOperation = async () => {
    if (!checkBoxList || checkBoxList.length <= 0) {
      SwalMessage({
        title: "جهت ادامه فرایند ابتدا آیتم های مورد نظر را انتخاب نمایید.",
        iSsuccess: false,
        timer: 4000,
      });
      return;
    }
    setShowDeleteOperationStepModal(true);
    setDeleteStep(1);
    setCurrentDeleteStep(0);
    handleModalGaranty(checkBoxList, "DeleteOprationCancelStatus");
  };

  const cancelStatusMessage =
    props?.basketItems &&
    props.basketItems.map((item) => {
      const cancelStatusArray = [];
      for (const item1 of item?.basketItemPersons) {
        cancelStatusArray.push(+item1.cancelStatus);
      }
      if (cancelStatusArray.includes(1)) {
        return {
          style: {
            color: "rgb(246, 78, 96)", // قرمز پر رنگ
          },
          text: "درخواست کنسلی",
        };
      } else if (cancelStatusArray.includes(2)) {
        return {
          style: {
            color: "rgb(199 188 219)",
          },
          text: "پیگیری کنسلی",
        };
      } else if (cancelStatusArray.includes(5)) {
        return {
          style: {
            color: "rgba(213, 149, 14, 0.4)",
          },
          text: "رد درخواست کنسلی",
        };
      } else if (cancelStatusArray.every((cancelStatus) => cancelStatus == 4)) {
        return {
          style: {
            color: "rgba(153, 39, 8, 0.4)",
          },
          text: "کنسل شد",
        };
      } else {
        return {
          style: {
            color: "rgb(182, 206, 232)",
          },
          text: "دیگر وضعیت ",
        };
      }
    });
  const steps = ["عملیـات کنسـلی تامین کننده", "عملیـات کنسلـی کاربر", " پایان عملیـات کـنسلی"];
  const deleteSteps = ["حذف فرایند کنسلی کاربر", "حذف فرایند کنسلی تامین کننده", " پایان عملیات حذف فرایند"];
  const [currentStep, setCurrentStep] = useState(0);
  const [currentDeleteStep, setCurrentDeleteStep] = useState(0);
  const [step, setStep] = useState(1);
  const [deleteStep, setDeleteStep] = useState(1);
  const [showStepModal, setShowStepModal] = useState(false);
  const [showDeleteOperationStepModal, setShowDeleteOperationStepModal] = useState(false);
  const [showFineRegisterModal, setShowFineRegisterModal] = useState(false);

  const handleCloseFineRegisterModal = () => {
    setShowFineRegisterModal(false);
  };
  const handleCloseStepModal = () => {
    setShowStepModal(false);
    setStep(1);
    setCurrentStep(0);
    setStepCompleted({
      step1: false,
      step2: false,
      deleteStep1: false,
      deleteStep2: false,
    });
  };
  const handleCloseDeleteOperationStepModal = () => {
    setShowDeleteOperationStepModal(false);
    setDeleteStep(1);
    setCurrentDeleteStep(0);
    setStepCompleted({
      step1: false,
      step2: false,
      deleteStep1: false,
      deleteStep2: false,
    });
  };
  const handleShowStepModal = () => {
    handleModalGaranty(checkBoxList, "SupplierCancelStatus");
  };

  const handleShowFineRegisterModal = () => {
    handleModalGaranty(checkBoxList, "FineAmount");
  };

  const handleNext = () => {
    if (step < 3) setStep(step + 1);
    handleModalGaranty(checkBoxList, "CancelStatus");
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (step > 1) setStep(step - 1);
    if (step === 3) handleModalGaranty(checkBoxList, "CancelStatus");
    else if (step === 2) handleModalGaranty(checkBoxList, "SupplierCancelStatus");
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const handleNextDeleteOpration = () => {
    if (deleteStep < 3) setDeleteStep(deleteStep + 1);
    handleModalGaranty(checkBoxList, "DeleteOprationSupplierCancelStatus");
    if (currentDeleteStep < deleteSteps.length - 1) setCurrentDeleteStep(currentDeleteStep + 1);
  };

  const handlePrevDeleteOpration = () => {
    if (deleteStep > 1) setDeleteStep(deleteStep - 1);
    if (deleteStep === 3) handleModalGaranty(checkBoxList, "DeleteOprationSupplierCancelStatus");
    else if (deleteStep === 2) handleModalGaranty(checkBoxList, "DeleteOprationCancelStatus");
    if (currentDeleteStep > 0) setCurrentDeleteStep(currentDeleteStep - 1);
  };
  return (
    <>
      {/* -------------دراپ دون کنار صفحه -------------------------------------------------------------------------------------------- */}
      <Dropdown className=" sticky-top " style={{ position: "fixed", top: pageHeight / 2, left: "-16px" }}>
        <Dropdown.Toggle size="sm" drop="up" variant="primary" className=" position-absolute right-0 fa-rotate-270">
          عملیات
        </Dropdown.Toggle>
        <Dropdown.Menu className="">
          <Dropdown.Item className="m-0 p-0 px-4 ">
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => handleShowStepModal()}
            >
              عملیات کنسلی
            </button>
          </Dropdown.Item>
          <Dropdown.Item className="m-0 p-0 px-4 ">
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => handleShowFineRegisterModal()}
            >
              ثبت جریمه
            </button>
          </Dropdown.Item>
          <Dropdown.Item className="m-0 p-0 px-4 ">
            <button
              className="btn btn-outline-primary ml-auto my-0 px-5  btn-sm col-12"
              onClick={() => deleteCancellationOperation(checkBoxList)}
            >
              حذف فرایند انجام شده
            </button>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      {/* ========================================================================================================================== */}
      {/* -------------------------ایتم ها ی سبد خرید ------------------------------------------------------------------------------- */}
      <div className="mt-5">
        {props &&
          props.basketItems &&
          props.basketItems.map((item, index) => (
            <Card
              style={{ opacity: cancelStatusMessage[index].text == "دیگر وضعیت" ? `50%` : `100%` }}
              key={index}
              className=" rounded-xl mt-1 mx-0 p-3 bg-white border border-secondary"
            >
              <div className="my-0">
                <Row className="align-items-center mb-2 border-bottom">
                  <Col>
                    <h1 className="mx-3 mt-3 mb-1 pb-3 text-hover-primary fs-large">
                      {item.amusementServiceName}
                      <span style={cancelStatusMessage[index].style}>
                        | {cancelStatusMessage[index].text == "دیگر وضعیت" ? "" : cancelStatusMessage[index].text}
                      </span>
                    </h1>
                  </Col>
                </Row>
              </div>
              {/*------------------------------------------------------- مشخصات سفارش ------------------------------------------*/}
              <div className="">
                <Row className="pl-2 my-2 ">
                  <Col xs="12" md lg="12" xl="5" className="mb-3 text-muted">
                    جزییات سفارش : {showDetail(item.details)}
                  </Col>
                  <Col xs="6" sm="3" md="2" lg="3" xl>
                    <p>
                      <span className="fas fa-user-tie text-primary mr-2"></span>
                      {item.totalCount} نفر{" "}
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2" lg="3" xl>
                    <p className="">
                      <span className="far fa-calendar-check text-info mr-2"></span>
                      {item.checkInDate}{" "}
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2" lg="3" xl className="">
                    <p className="" data-bs-toggle="tooltip" title="مبلغ نهایی تفریح">
                      <span className="far fa-money-bill-alt text-success  mr-2"></span>
                      {showPrice.format(item.sumPrice)}{" "}
                      <span>
                        <small> تومان </small>
                      </span>
                    </p>
                  </Col>
                  <Col xs="6" sm="3" md="2" lg="3" xl className="">
                    <p className="" data-bs-toggle="tooltip" title="مبلغ پرداختی به تامین کننده">
                      <span className="far fa-money-bill-alt text-danger mr-2"></span>
                      {showPrice.format(item.warantyAmount)}{" "}
                      <span>
                        <small> تومان </small>
                      </span>
                    </p>
                  </Col>
                </Row>
              </div>
              {/* ------------------------------------------------لیست افراد حاضر در ایتم------------------------------------------------------------ */}
              <div className="table-wrapper bg-secondary rounded-4 mb-4 ">
                <Table responsive className="mt-1 tbl-scroll ">
                  <thead>
                    <tr className="">
                      <td className="bg-secondary">
                        <i className="bi bi-ban"></i>
                        <input
                          type="checkbox"
                          onChange={() => {
                            handleAllSelect(
                              item.basketItemPersons,
                              item?.basketItemPersons.filter((item) => {
                                // filter those items in the basketItemPersons that exist in the checkBoxList ↓↓
                                return checkBoxList.some((data) => item.id === data.id);
                              }).length === item?.basketItemPersons.length,
                            );
                          }}
                          className="ml-1 ml-xl-6 pl-6 my-1 "
                          checked={
                            item?.basketItemPersons.filter((item) => checkBoxList.some((data) => item.id === data.id))
                              .length === item?.basketItemPersons.length && item?.basketItemPersons.length > 0
                          }
                        />
                      </td>
                      <td className="bg-secondary"></td>
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-muted">شماره بلیط</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "130px" }}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-muted">نام و نام خانوادگی</p>
                      </td>
                      {!!item.hallEventId && <td className="bg-secondary" style={{ minWidth: "130px" }}>
                        <p className="text-center my-1 ml-6 ml-md-0 text-muted">صندلی</p>
                      </td>}
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">نرخ مصوب</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 text-muted my-1">نرخ فروش</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 text-muted my-1">تخفیف کد</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "100px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">قیمت نهایی</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">تامین کننده</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "80px" }}>
                        <p className="text-center ml-6 ml-md-0 my-1 text-muted">جریمه</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "90px" }}>
                        <p className={"text-md-center ml-6 ml-md-0 my-1 text-muted"}>وضعیت</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "90px" }}>
                        <p className={"text-center  ml-md-0 my-1 text-muted"}>وضعیت کنسلی</p>
                      </td>
                      <td className="bg-secondary" style={{ minWidth: "90px" }}>
                        <p className={"text-center  ml-md-0 my-1 text-muted"}>کنسلی تامین کننده </p>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {item.basketItemPersons.length !== 0 ? (
                      item.basketItemPersons.map((item1, index1) => (
                        <tr
                          key={index1}
                          className={classNames(
                            " ",
                            item1.cancelStatus == 1
                              ? "bg-1"
                              : item1.cancelStatus == 2
                                ? "bg-2"
                                : item1.cancelStatus == 3
                                  ? "bg-3"
                                  : item1.cancelStatus == 4
                                    ? "bg-4"
                                    : item1.cancelStatus == 5 && "bg-5",
                          )}
                        >
                          {/* -------------------------------- CHECKBOX-------------------------------------------------------------*/}
                          {item1.cancelStatus === null ? (
                            <div>
                              <BlockIcon fontSize="inherit" sx={{ color: "red", width: "40px" }} />
                            </div>
                          ) : (
                            <td>
                              <div className="d-flex justify-content-between w-100">
                                <input
                                  type={"checkbox"}
                                  checked={
                                    item1.cancelStatus !== null && checkBoxList.some((item) => item1.id === item.id)
                                  }
                                  onChange={() => {
                                    handleSelect(item1, item1.basketItemId)
                                  }}
                                  className="ml-1 ml-xl-6 pl-6"
                                />
                              </div>
                            </td>
                          )}
                          <td>
                            {item1.issueTicketType == 2 && (
                              <i
                                className={`${item1.currentStatus == 3 ? "text-warning flaticon2-print icon-md mt-3" : "flaticon2-print icon-md mt-3"} `}
                              ></i>
                            )}
                            {!!item1.amusementServiceReserveItemTicketSourceId &&
                              <Tippy
                                content={
                                  <div>
                                    <div>این آیتم دارای بلیط منبع می‌باشد</div>
                                    <div>شناسه بلیط منبع: {item1.amusementServiceReserveItemTicketSourceId}</div>
                                  </div>
                                }
                                hideOnClick={false}
                              >
                                <i className="fas fa-ticket me-2 text-info" />
                              </Tippy>}
                          </td>
                          {/* -------------------------------- ID-------------------------------------------------------------*/}
                          <td onClick={() => handleSelect(item1)}>
                            <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.id}</p>
                          </td>

                          <td className="" onClick={() => handleSelect(item1)}>
                            <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">{item1.personFullName}</p>
                          </td>
                          {!!item.hallEventId &&
                            <td className="" onClick={() => handleSelect(item1)}>
                              <p className="text-center my-1 ml-6 ml-md-0 text-hover-primary">جایگاه: {item1.hallBlockName}
                                <br />
                               ردیف: {item1.hallRowName}
                                <br />
                                صندلی: {item1.hallSeatName}
                              </p>
                            </td>
                          }
                          <td onClick={() => handleSelect(item1)}>
                            <p
                              className="text-center ml-6 ml-md-0 my-1 text-hover-primary"
                              style={{ textDecoration: "line-through" }}
                            >
                              {showPrice.format(item1.originalPrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1)}>
                            <p
                              className="text-center ml-6 ml-md-0 text-hover-primary my-1"
                              style={item1.promoCodeDiscountPrice > 0 ? { textDecoration: "line-through" } : {}}
                            >
                              {showPrice.format(item1.salePrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1)}>
                            <p className="text-center ml-6 ml-md-0 text-hover-primary my-1">
                              {showPrice.format(item1.promoCodeDiscountPrice)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1)}>
                            <p className="text-center  ml-md-0 my-1 text-hover-primary">
                              {showPrice.format(item1.price)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1)} style={{ color: "#0e0e0e70" }}>
                            <p
                              className={
                                item1.warantyAmount >= 0
                                  ? "text-center ml-6 ml-md-0 my-1 text-hover-primary"
                                  : "text-center ml-6 ml-md-0 my-1 text-hover-primary text-danger"
                              }
                            >
                              {showPrice.format(item1.warantyAmount)}
                            </p>
                          </td>
                          <td onClick={() => handleSelect(item1)}>
                            <p className="text-center ml-6 ml-md-0 my-1 text-hover-primary">
                              {showPrice.format(item1.fineAmount)}
                            </p>
                          </td>
                          {/* -------------------------------- وضعیت-------------------------------------------------------------*/}
                          <td onClick={() => handleSelect(item1)} className="px-0 mx-0">
                            <p className={"text-center  ml-md-0 my-1 "}>
                              <span
                                className={
                                  item1.currentStatus == 0
                                    ? "text-primary "
                                    : item1.currentStatus == 1
                                      ? "text-warning "
                                      : item1.currentStatus == 2
                                        ? "text-info "
                                        : item1.currentStatus == 3
                                          ? "text-success "
                                          : item1.currentStatus == 4 && "text-danger "
                                }
                              >
                                {item1.currentStatusS}
                              </span>
                            </p>
                          </td>
                          {/* --------------------------------  وضعیت کنسلی------------------------------------------------------------*/}
                          <td onClick={() => handleSelect(item1)}>
                            <p className={"text-center ml-md-0 my-1 "}>
                              <span
                                style={{
                                  color:
                                    item1.cancelStatus == 0
                                      ? "text-primary "
                                      : item1.cancelStatus == 1
                                        ? "rgb(246, 78, 96) "
                                        : item1.cancelStatus == 2
                                          ? "rgb(168 160 184)"
                                          : item1.cancelStatus == 3
                                            ? "rgb(54, 153, 255)"
                                            : item1.cancelStatus == 4
                                              ? "rgba(153, 39, 8, 0.4)"
                                              : item1.cancelStatus == 5 && "rgba(213, 149, 14, 0.4)",
                                }}
                              >
                                {item1.cancelStatus == 0 ? "" : item1.cancelStatusS}
                              </span>
                            </p>
                          </td>
                          {/* --------------------------------  وضعیت کنسلی تامین کننده------------------------------------------------------------*/}
                          <td onClick={() => handleSelect(item1)}>
                            <p className={"text-center ml-md-0 my-1 "}>
                              <span
                                style={{
                                  color:
                                    item1.supplierCancelStatus == 0
                                      ? "text-primary "
                                      : item1.supplierCancelStatus == 1
                                        ? "rgb(246, 78, 96) "
                                        : item1.supplierCancelStatus == 2
                                          ? "rgb(168 160 184)"
                                          : item1.supplierCancelStatus == 3
                                            ? "rgb(54, 153, 255)"
                                            : item1.supplierCancelStatus == 4
                                              ? "rgba(153, 39, 8, 0.4)"
                                              : item1.supplierCancelStatus == 5 && "rgba(213, 149, 14, 0.4)",
                                }}
                              >
                                {item1.supplierCancelStatus == 0 ? "" : item1.supplierCancelStatusS}
                              </span>
                            </p>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr className="text-danger ">
                        <td colSpan="13">
                          <small className="text-danger ">برای این فعالیت هنوز فردی ثبت نشده است !!</small>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
            </Card>
          ))}
      </div>
      {/********************** مدال کنسلی تامین کننده و کاربر به صورت استپ ****************************************/}
      <Modal centered dialogClassName="modal-90w" show={showStepModal} onHide={handleCloseStepModal}>
        <Modal.Header closeButton>
          <Modal.Title> عملیات کنسلی</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="text-center mt-5">
            <div className="justify-content-center mb-4 stepper-row d-flex">
              {steps.map((label, index) => (
                <React.Fragment key={index}>
                  <Col xs="auto" className="step-container position-relative px-4">
                    <div className={`step-circle ${index <= currentStep ? "active" : ""}`}>{index + 1}</div>
                    <div className={`step-label text-small-1 ${index === currentStep ? "active" : ""}`}>{label}</div>
                    {index < steps.length - 1 && (
                      <div className={`connector ${index < currentStep ? "active" : ""}`}></div>
                    )}
                  </Col>
                </React.Fragment>
              ))}
            </div>
          </Container>
          <div className="stepper">
            <div className=" border-bottom pb-5 mb-5">
              <div className="step d-flex flex-column flex-md-row align-items-center justify-content-center">
                <h4 className="mb-0">
                  {step === 1 && "مرحله 1 : عملیات کنسلی تامین کننده"}
                  {step === 2 && "مرحله 2 : عملیات کنسلی کاربر"}
                  {step === 3 && "مرحله 3 : پایان عملیات کنسلی"}
                </h4>
                <p className="mb-0 px-2">
                  {step === 1 && "( در این مرحله عملیات کنسلی برای تامین کننده انجام می شود.)"}
                  {step === 2 && "(در این مرحله عملیات کنسلی برای کاربر انجام می شود.)"}
                </p>
              </div>
              {step === 1 && stepCompleted.step1 && (
                <div className="d-flex align-items-center justify-content-center">
                  <div className="bg-light-success text-success rounded-3 py-3 px-5 mt-5">
                    <CheckCircleOutlineIcon />
                    <span className="mx-1">مرحله 1 (عملیات کنسلی تامین کننده) تکمیل شده است.</span>
                  </div>
                </div>
              )}
              {step === 2 && stepCompleted.step2 && (
                <div className="d-flex align-items-center justify-content-center">
                  <div className="bg-light-success text-success rounded-3 py-3 px-5 mt-5">
                    <CheckCircleOutlineIcon />
                    <span className="mx-1">مرحله 2 (عملیات کنسلی کاربر) تکمیل شده است.</span>
                  </div>
                </div>
              )}
            </div>
            {loadingData ? (
              <div className="py-5 text-center">درحال دریافت اطلاعات ... </div>
            ) : step < 3 ? (
              <Modali />
            ) : (
              <div className="d-flex align-items-center justify-content-center my-5">
                <div className="bg-light-success text-success rounded-3 py-3 px-5 mt-5 fs-medium">
                  <CheckCircleOutlineIcon />
                  <span className="mx-1"> عملیات کنسلی تامین کننده و کاربر با موفقیت به اتمام رسید.</span>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-between justify-content-lg-end">
          {((step === 1 && !stepCompleted.step1) || (step === 2 && !stepCompleted.step2)) && (
            <div className="">برای ثبت اطلاعات این مرحله روی دکمه ذخیره کلیک نمایید تا اطلاعات ذخیره گردد </div>
          )}
          <div>
            {step > 1 && (
              <Button variant="secondary" className="me-2" onClick={handlePrev} disabled={step === 1}>
                قبلی
              </Button>
            )}
            {step === 1 && (
              <Button variant="primary" className="me-2" onClick={handleNext}>
                مرحله بعدی
              </Button>
            )}
            {step === 2 && (
              <Button
                variant="primary"
                className="me-2"
                onClick={handleNext}
                disabled={!stepCompleted.step1 || !stepCompleted.step2}
              >
                پایان عملیات کنسلی
              </Button>
            )}
            <Button variant="secondary" className="me-2" onClick={handleCloseStepModal}>
              بستن
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/*************************************** مدال ثبت جریمه ****************************************************/}
      <Modal
        centered
        dialogClassName="modal-90w"
        show={showFineRegisterModal}
        onHide={handleCloseFineRegisterModal}
      >
        <Modal.Header closeButton>
          <Modal.Title> عملیات ثبت جریمه</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modali />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFineRegisterModal(false)}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
      {/************************* مدال  حذف فرایند انجام شده به صورت استپ *********************************/}
      <Modal
        centered
        dialogClassName="modal-90w"
        show={showDeleteOperationStepModal}
        onHide={handleCloseDeleteOperationStepModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>حذف فرآیند انجام شده</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="text-center mt-5">
            <div className="justify-content-center mb-4 stepper-row d-flex">
              {deleteSteps.map((label, index) => (
                <React.Fragment key={index}>
                  <Col xs="auto" className="step-container position-relative px-2">
                    <div className={`step-circle ${index <= currentDeleteStep ? "active" : ""}`}>{index + 1}</div>
                    <div className={`step-label text-small-1 ${index === currentDeleteStep ? "active" : ""}`}>
                      {label}
                    </div>
                    {index < deleteSteps.length - 1 && (
                      <div className={`connector ${index < currentDeleteStep ? "active" : ""}`}></div>
                    )}
                  </Col>
                </React.Fragment>
              ))}
            </div>
          </Container>
          <div className="stepper">
            <div className=" border-bottom pb-5 mb-5">
              <div className="step d-flex flex-column flex-md-row align-items-center justify-content-center">
                <h4 className="mb-0">
                  {deleteStep === 1 && "مرحله 1 : حذف فرایند کنسلی کاربر"}
                  {deleteStep === 2 && "مرحله 2 : حذف فرایند کنسلی تامین کننده"}
                  {deleteStep === 3 && "مرحله 3 : پایان عملیات حذف فرایند کنسلی"}
                </h4>
                <p className="mb-0 px-2">
                  {deleteStep === 1 && "( در این مرحله عملیات حذف فرایند کنسلی برای کاربر انجام می شود.)"}
                  {deleteStep === 2 && "(در این مرحله عملیات حذف فرایند کنسلی برای تامین کننده انجام می شود.)"}
                </p>
              </div>
            </div>
            {deleteStep < 3 ? (
              <Modali />
            ) : (
              <div className="d-flex align-items-center justify-content-center my-5">
                <div className="bg-light-success text-success rounded-3 py-3 px-5 mt-5 fs-medium">
                  <CheckCircleOutlineIcon />
                  <span className="mx-1"> عملیات حذف فرایند کنسلی کاربر و تامین کننده با موفقیت به اتمام رسید.</span>
                </div>
              </div>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer className="d-flex align-items-center justify-content-between justify-content-lg-end">
          <div>
            {deleteStep > 1 && (
              <Button
                variant="secondary"
                className="me-2"
                onClick={handlePrevDeleteOpration}
                disabled={deleteStep == 1}
              >
                قبلی
              </Button>
            )}
            {deleteStep == 1 && (
              <Button variant="primary" className="me-2" onClick={handleNextDeleteOpration}>
                مرحله بعدی
              </Button>
            )}
            {deleteStep == 2 && (
              <Button
                variant="primary"
                className="me-2"
                onClick={handleNextDeleteOpration}
                disabled={!stepCompleted.deleteStep1 || !stepCompleted.deleteStep2}
              >
                پایان عملیات
              </Button>
            )}
            <Button variant="secondary" className="me-2" onClick={handleCloseDeleteOperationStepModal}>
              بستن
            </Button>
          </div>
        </Modal.Footer>
        {/* </form> */}
      </Modal>
    </>
  );
}

export default BasketCanceledItemsIndex;
